import {
  FOCUS_RING_CONTRAST_FLOOR,
  FOCUS_RING_WIDTH_PX,
  RING_INK_DARK,
  RING_INK_LIGHT,
  RING_PALETTE_SLOTS,
  chooseRingInk,
  contrastRatio,
  focusRing,
  focusRingColors,
  focusRingInkDecisions,
  focusVisibleComponents,
  relativeLuminance
} from "./chunk-GOUF5BMY.mjs";

// src/theme/toMUITheme.ts
import { toMUITheme as designSystemTheme } from "@hopdrive/ui/theme";
function withFocusRing(base) {
  const theme = base;
  const palette = theme.palette;
  if (!palette) {
    throw new Error("withFocusRing: the theme has no palette, so the ring has no surface to measure against");
  }
  const mode = palette.mode === "dark" ? "dark" : "light";
  const complete = typeof palette.background?.paper === "string" && typeof palette.background?.default === "string" && RING_PALETTE_SLOTS.every(
    (slot) => typeof palette[slot]?.main === "string" && typeof palette[slot]?.dark === "string"
  );
  const usable = complete ? palette : void 0;
  const fragment = focusVisibleComponents(mode, usable);
  const components = { ...theme.components ?? {} };
  for (const [name, override] of Object.entries(fragment)) {
    const existing = components[name];
    const existingRoot = existing?.styleOverrides?.root;
    if (typeof existingRoot === "function") {
      throw new Error(
        `withFocusRing: ${name}.styleOverrides.root is a callback, and the focus ring cannot be appended to one. Spread focusVisibleComponents(mode, palette).${name}.styleOverrides.root inside that callback instead.`
      );
    }
    components[name] = {
      ...existing,
      styleOverrides: {
        ...existing?.styleOverrides,
        // Base keys first, ring keys after. The ring ties the base's `&:hover`
        // on specificity, so this order is what keeps it on a hovered control.
        root: { ...existingRoot, ...override.styleOverrides.root }
      }
    };
  }
  return { ...theme, components };
}
function toMUITheme(mode) {
  return withFocusRing(designSystemTheme(mode));
}
export {
  FOCUS_RING_CONTRAST_FLOOR,
  FOCUS_RING_WIDTH_PX,
  RING_INK_DARK,
  RING_INK_LIGHT,
  RING_PALETTE_SLOTS,
  chooseRingInk,
  contrastRatio,
  focusRing,
  focusRingColors,
  focusRingInkDecisions,
  focusVisibleComponents,
  relativeLuminance,
  toMUITheme,
  withFocusRing
};
//# sourceMappingURL=theme.mjs.map